import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';

interface GeneralDropdownsTriggersTriggerPowerSelectKebabSignature {
  Args: {
    buttonType?: 'secondary';
    size?: 'large' | 'medium' | 'small';
  };
}

const GeneralDropdownsTriggersTriggerPowerSelectKebab: TOC<GeneralDropdownsTriggersTriggerPowerSelectKebabSignature> =
  <template>
    <div class="trigger__content flex items-center">
      <PrismButton
        @buttonType={{if @buttonType @buttonType "ghost"}}
        @icon="kebab"
        @size={{@size}}
      />
    </div>
  </template>;

export default GeneralDropdownsTriggersTriggerPowerSelectKebab;
